import { useState } from 'react';
import { getStoredTheme, setStoredTheme, type ShopTheme } from '@/lib/theme';

/** Theme toggle state. The stored theme is applied at boot in main.tsx; this
 *  hook drives the header toggle + re-renders. */
export function useShopTheme() {
  const [theme, setTheme] = useState<ShopTheme>(getStoredTheme);
  const toggle = () => {
    const next: ShopTheme = theme === 'dark' ? 'light' : 'dark';
    setStoredTheme(next);
    setTheme(next);
  };
  return { theme, toggle };
}
